import React from 'react';
import {Humidity} from 'react-environment-chart';

interface SmHumidityProps {
    value: number;
    height?: number ;
    tips?: string[];
}

const SmHumidity: React.FC<SmHumidityProps> = (props: SmHumidityProps) => {

    return (
        <div>
            <Humidity value={props.value} height={props.height || 70} tips={props.tips || [' ', ' ', ' ', ' ']}/>
        </div>
    )
}

export default SmHumidity;